/* eslint-disable no-unused-vars */
import {
  FormControl,
  Input,
  MenuItem,
  OutlinedInput,
  Select
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import SVG from "react-inlinesvg";
import { getPages, getPagesCount } from "../../../_helpers";
import { toAbsoluteUrl } from "../../../_helpers/AssetsHelpers";

const useStyles = makeStyles((theme) => ({
  container: {
    displaydd: "flex",
    flexWrapdd: "wrap",
  },
  textField: {
    marginRight: "10px",
    marginLeft: "10px",
    marginTop: "7px",
    width: "36px",
    height: "36px",
    backgroundColor: "#f3f6f9",
    textAlign: "center",
    align: "middle",
    borderRadius: "4px",
    [theme.breakpoints.down("md")]: {
      width: (mobileViewPagination) => mobileViewPagination && "87px",
      height: (mobileViewPagination) => mobileViewPagination && "37px",
      border: (mobileViewPagination) =>
        mobileViewPagination && "solid 1px #ccd6e3",
    },
  },
  toolbar: {
    [theme.breakpoints.down("md")]: {
      padding: (mobileViewPagination) =>
        mobileViewPagination && "0px !important",
      height: (mobileViewPagination) => mobileViewPagination && "25px",
      marginLeft: (mobileViewPagination) => mobileViewPagination && "-25px",
      fontSize: (mobileViewPagination) => mobileViewPagination && "13px",
      fontWeight: (mobileViewPagination) => mobileViewPagination && "500",
    },
  },
  pageLinks: {
    [theme.breakpoints.down("md")]: {
      width: (mobileViewPagination) => mobileViewPagination && "100%",
      justifyContent: (mobileViewPagination) =>
        mobileViewPagination && "space-between",
      alignItems: (mobileViewPagination) => mobileViewPagination && "end",
    },
  },
  paginate: {
    [theme.breakpoints.down("md")]: {
      flexFlow: (mobileViewPagination) =>
        mobileViewPagination && "column-reverse",
    },
  },

  textField22: {
    marginRightdd: "10px",
    marginLeftdd: "10px",
    marginTop: "7px",
    width: "45px",
    height: "45px",
    backgroundColor: "#f3f6f9",
    textAlign: "center",
    align: "middle",
    borderRadius: "7px",
    border: "solid 1px #ccd6e3",
  },
  input: {
    textAlign: "center",
  },

  dense: {
    marginTop2: 19,
  },
  menu: {
    width: 200,
  },
}));

const useOutlinedInputStyles = makeStyles((theme) => ({
  root: {
    "& $notchedOutline": {
      borderColor: "rgb(44, 54, 135)",
    },
    "&:hover $notchedOutline": {
      borderColor: "rgb(44, 54, 135)",
    },
    "&$focused $notchedOutline": {
      borderColor: "rgb(44, 54, 135)",
    },
  },
  focused: {},
  notchedOutline: {},
}));

const useStyles2 = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 50,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
}));

export function PaginationLinks({
  paginationProps,
  mobileViewPagination,
  version,
}) {
  const { totalSize, sizePerPage, page, paginationSize } = paginationProps;
  const pagesCount = getPagesCount(totalSize, sizePerPage);
  const pages = getPages(page, pagesCount, paginationSize);

  const handleFirstPage = ({ onPageChange }) => {
    onPageChange(1);
    setValues({ ...values, pagei: 1 });
  };

  useEffect(() => {
    handleFirstPage(paginationProps);
  }, [sizePerPage]);

  useEffect(() => {
    if (page > pagesCount) handleFirstPage(paginationProps);
  }, [pagesCount]);

  const handlePrevPage = ({ page, onPageChange }) => {
    if (page > 1) {
      onPageChange(page - 1);
      setValues({ ...values, pagei: page - 1 });
    }
  };

  const handleNextPage = ({ page, onPageChange }) => {
    if (page < pagesCount) {
      onPageChange(page + 1);
      if (page < pagesCount) setValues({ ...values, pagei: page + 1 });
    }
  };

  const [values, setValues] = React.useState({
    pagei: page,
  });

  useEffect(() => {
    setValues({ ...values, pagei: paginationProps.page });
  }, [paginationProps]);

  const classes = useStyles(mobileViewPagination);
  const handleChange = (value1, onPageChange) => {
    let value = 0;
    value1 = value1.replace(/[^\d]+/g, "");
    if (value1 === "") {
      setValues({ ...values, pagei: "" });
      return;
    }

    if (value1 !== "") {
      try {
        value = parseInt(value1, 10);
      } catch (e) {}
    }

    if (value === 0) {
      setValues({ ...values, pagei: "" });
      return;
    }

    if (value1 !== "" && (value > pagesCount || value < 1)) return;
    setValues({ ...values, pagei: value });
    if (value1 !== "") onPageChange(parseInt(value1));
  };

  const disabledClass = pagesCount >= 1 ? "" : "disabled";
  return (
    <>
      {pagesCount < 2 && <></>}
      {pagesCount >= 1 && (
        <>
          <div
            style={{ width: "100%" }}
            className={`d-block d-lg-none qpage  py-2 mr-3 ${disabledClass}  ${classes.pageLinks}`}
          >
            <div
              style={{ justifyContent: "space-between", alignItems: "center" }}
              className={`d-block d-lg-none qpage d-flex flex-wrap py-2 mr-3 ${disabledClass}`}
            >
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  handlePrevPage(paginationProps);
                }}
                className="btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
              >
                <SVG
                  src={toAbsoluteUrl("/media/sr/icons/pagination-left.svg")}
                />
              </a>

              <span>
                <Input
                  id="pagei"
                  label=""
                  type="text"
                  classes={{
                    root: classes.textField,
                  }}
                  autoComplete="off"
                  disableUnderline={true}
                  value={values.pagei}
                  onChange={(event) => {
                    handleChange(
                      event.target.value,
                      paginationProps.onPageChange
                    );
                  }}
                  ddmargin="normal"
                  inputProps={{
                    pattern: "[1-9]+",
                    style: { textAlign: "center", max: pagesCount, min: 1 },
                  }}
                  ddInputProps={{
                    inputProps: {
                      max: pagesCount,
                      min: 1,
                    },
                  }}
                />
              </span>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  handleNextPage(paginationProps);
                }}
                className="ml-5 btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
              >
                <SVG
                  src={toAbsoluteUrl("/media/sr/icons/pagination-right.svg")}
                />
              </a>
            </div>
            {version === 2 && pagesCount > 1 && (
              <div
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className={`d-block d-lg-none qpage d-flex flex-wrap py-2 mr-3 ${disabledClass}`}
              >
                <span style={{ width: "94%" }} className=" btn  ddmr-2 my-1">
                  Out of {pagesCount}
                </span>
              </div>
            )}
          </div>

          <div className={`d-none d-lg-block qpage  ${disabledClass}`}>
            <div
              className={`d-flex flex-wrap d-none d-lg-block qpage  py-2 mr-3 ${disabledClass}`}
            >
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  handlePrevPage(paginationProps);
                }}
                className="btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
              >
                <SVG
                  src={toAbsoluteUrl("/media/sr/icons/pagination-left.svg")}
                />
              </a>

              <span>
                <Input
                  id="pagei"
                  label=""
                  type="text"
                  classes={{
                    root: classes.textField,
                  }}
                  autoComplete="off"
                  disableUnderline={true}
                  value={values.pagei}
                  onChange={(event) => {
                    handleChange(
                      event.target.value,
                      paginationProps.onPageChange
                    );
                  }}
                  ddmargin="normal"
                  inputProps={{
                    pattern: "[1-9]+",
                    style: { textAlign: "center", max: pagesCount, min: 1 },
                  }}
                  ddInputProps={{
                    inputProps: {
                      max: pagesCount,
                      min: 1,
                    },
                  }}
                />
              </span>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  handleNextPage(paginationProps);
                }}
                className="ml-5 btn btn-icon btn-sm btn-lightdd btn-hover-primarydd mr-2 my-1"
              >
                <SVG
                  src={toAbsoluteUrl("/media/sr/icons/pagination-right.svg")}
                />
              </a>

              {version === 2 && pagesCount > 1 && (
                <span className=" btn  mr-2 my-1">Out of {pagesCount}</span>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export function PaginationToolbar(props) {
  const { isLoading, paginationProps, mobileViewPagination } = props;
  const {
    page,
    paginationSize,
    hideSizePerPage,
    sizePerPageAsEntriesDropdown = false,
    displayOutofTotal = true,
  } = paginationProps;
  const classes = useStyles(mobileViewPagination);
  const {
    sizePerPageList,
    sizePerPage,
    totalSize,
    onSizePerPageChange = [
      { text: "10", value: 10 },
      { text: "25", value: 25 },
      { text: "50", value: 50 },
    ],
  } = paginationProps;
  const style = {
    width: "75px",
  };

  const pagesCount = getPagesCount(totalSize, sizePerPage);

  const onSizeChange = (event, onPageChange) => {
    const newSize = +event.target.value;
    onSizePerPageChange(newSize);
    onPageChange(1);
  };

  //
  const classes2 = useStyles2();
  const outlinedInputClasses = useOutlinedInputStyles();
  const [values, setValues] = React.useState({
    age: "",
    name: "hai",
  });

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);

  function handleSelectPageChange(event) {
    const newSize = +event.target.value;
    onSizePerPageChange(newSize);
  }

  return (
    <div className="d-none d-lg-flex d-flex align-items-center py-3 ">
      {props.version === 2 ? (
        <>
          <div className="d-none d-lg-block">
            <div className="d-flex align-items-center py-3 ">
              <span className="mr-4">Show</span>
              <FormControl variant="outlined" className={classes2.formControl}>
                <Select
                  className="pagination-select"
                  value={sizePerPage}
                  onChange={handleSelectPageChange}
                  input={
                    <OutlinedInput
                      labelWidth={labelWidth}
                      name="age"
                      id="outlined-age-simple"
                      classes={outlinedInputClasses}
                    />
                  }
                >
                  {sizePerPageList.map((option, key) => {
                    return (
                      <MenuItem key={key} value={option.page}>
                        {option.page}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <span>Records per page</span>
            </div>
          </div>
        </>
      ) : (
        sizePerPageAsEntriesDropdown &&
        pagesCount >= 1 && (
          <>
            {!hideSizePerPage && (
              <>
                <span>Show</span>
                <select
                  disabled={totalSize === 0}
                  className={`ml-4 form-control form-control-sm font-weight-bold mr-4 border-0 bg-light ${totalSize ===
                    0 && "disabled"}`}
                  onChange={(event) => {
                    onSizeChange(event, paginationProps.onPageChange);
                  }}
                  value={sizePerPage}
                  style={style}
                >
                  {sizePerPageList.map((option) => {
                    const isSelect = sizePerPage === `${option.page}`;
                    return (
                      <option
                        key={option.text}
                        value={option.page}
                        className={`btn ${isSelect ? "active" : ""}`}
                      >
                        {option.text}
                      </option>
                    );
                  })}
                </select>
                {sizePerPageAsEntriesDropdown && (
                  <span className="mr-10">entries </span>
                )}
              </>
            )}
          </>
        )
      )}
      {props.version !== 2 && pagesCount >= 1 && (
        <div className="d-flex align-items-center py-3">
          {displayOutofTotal && (
            <span
              className={`react-bootstrap-table-pagination-total ${mobileViewPagination &&
                "ml-n10"}`}
            >
              {!mobileViewPagination && page} Out of {pagesCount}
            </span>
          )}
        </div>
      )}{" "}
      {isLoading && (
        <div className="d-flex align-items-center">
          <div className="mr-2 text-muted">&nbsp;Loading...</div>
          <div className="spinner spinner-primary mr-10"></div>
        </div>
      )}
    </div>
  );
}

export function Pagination(props) {
  const {
    children,
    isLoading,
    paginationProps,
    mobileViewPagination = false,
  } = props;
  const classes = useStyles(mobileViewPagination);

  return (
    <>
      {children}
      <div
        className={`d-flex justify-content-between align-items-center flex-wrap ${classes.paginate}`}
      >
        <PaginationToolbar
          isLoading={isLoading}
          paginationProps={paginationProps}
          mobileViewPagination={mobileViewPagination}
          version={props.version}
        />
        {props.version === 2 && <span>&nbsp;</span>}
        <PaginationLinks
          paginationProps={paginationProps}
          mobileViewPagination={mobileViewPagination}
          version={props.version}
        />
      </div>
    </>
  );
}
